<div class="footer">
  <atom-label class="footer__text" [text]="footerText"></atom-label>
  <atom-label class="footer__text" [text]="'MESSAGES.Todos los derechos reservados.' | translate"></atom-label>
</div>
